import { render, staticRenderFns } from "./FlickrCard.vue?vue&type=template&id=4fef613f&"
import script from "./FlickrCard.vue?vue&type=script&lang=js&"
export * from "./FlickrCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports